import { v1ApiClient } from '@/services';

export const deleteChart = async (alias: string) => {
  const res = await v1ApiClient.delete(`/charts/${alias}`);
  return res.data;
};
